module.exports = __webpack_public_path__ + "img/Flag_of_Switzerland.9c0735c8.svg";